import { Country } from '@types';

export const WORKING_LEVELS = [
    'Above',
    'Meeting',
    'Below',
    'Significantly below',
    'GCSE Grade 1',
    'GCSE Grade 2',
    'GCSE Grade 3',
    'GCSE Grade 4',
    'GCSE Grade 5',
    'GCSE Grade 6',
    'GCSE Grade 7',
    'GCSE Grade 8',
    'GCSE Grade 9',
] as const;

export type WorkingLevel = (typeof WORKING_LEVELS)[number];

export interface ProgrammeRecommendation {
    id: number;
    working_level: WorkingLevel;
    year_id: number;
    programme_id: number;
    programme_title: string;
    programme_country: Country;
}
